import angular from "angular";
import authService from './auth.service';

let authModule = angular.module('auth.service', [])
.service('Auth', authService)

.name;

export default authModule;



// WEBPACK FOOTER //
// ./client/app/services/authService/auth.js